export interface IToolWidget {
    id: string;
    name: string;
    // TODO: Use an Enum ?
    type: string;
    icon: string;
    thickness?: number;
    effect: string;
    separator?: boolean;

    html(activeTool: IToolWidget | null): string;
}

export class ToolWidget implements IToolWidget{
    id: string;
    name: string;
    type: string;
    icon: string;
    thickness?: number;
    effect: string;
    separator?: boolean;

    constructor(id: string, name: string, type: string, icon: string, thickness?:number, effect?: string, separator?: boolean){
        this.id = id;
        this.name = name;
        this.type = type;
        this.icon = icon;
        this.thickness = thickness;
        this.effect = effect || '';
        this.separator = separator
    }

    html(activeTool: IToolWidget | null): string{
        let subPlanActive: boolean = activeTool !== null && activeTool.id === this.id;
        let hideToolAttrib: boolean = activeTool === null || activeTool.id !== this.id;

        let html = `
            <div class="plan-tool" id="${this.id}Container">
                <!-- Tool -->
                <div class="sub-plan-tool ${ subPlanActive ? 'active': ''}" id="${this.id}%tool">

                    <!-- Tool icon -->
                    <div class="sub-sub-plan-tool ${this.effect}">
                        ${this.icon ? `<div class="plan-tool-icon ${this.icon}"></div>`: ''}
                    </div>

                    <!-- Tool name -->
                    <div class="plan-tool-title">
                        ${this.name}
                    </div>
                </div>
                ${this.separator !== undefined ? `
                <!-- Separator with next tool -->
                <div class="horizontal-separator right" style="margin-left:10px"></div>
                `:''}
                ${this.thickness !== undefined ? `
                <!-- If tool is a tool that contains a thichness setting (wall for instance) add an input box and +/- buttons -->
                <div class="plan-tool-attrib" ${hideToolAttrib ? 'style="display:none"': ''}>

                    <!-- Input field to enter thickness manually -->
                    <div class="thickness-field">
                        <input type="number" class="form-control" id="${this.id}%thickness" value="${this.thickness}">
                        <label class="input-label" for="${this.id}%thickness">cm</label>
                    </div>

                    <!-- + and - buttons to change the thickness setting -->
                    <div class="add-remove-buttons">
                        <div class="btn btn-flat btn-default min less" id="${this.id}%less"><i style="font-size:14px;">-</i></div>
                        <div class="btn btn-flat btn-default max more" id="${this.id}%more"><i style="font-size:10px;font-weight:900" class="material-icons icon-FloatBar_Plus"></i></div>
                    </div>

                    <!-- Separator with next tool in the event this one has a thickness setting -->
                    <div class="horizontal-separator right" style="margin-left:10px">
                    </div>
                </div>
                `:''}
            </div>`;
        return html;
    }
}